// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1kRkG","img":"Card_img__iFQG6","title":"Card_title__15_tC","description":"Card_description__3hakj"};